// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__16D7G","footer":"ChangeClinic_footer__3-j_M"};